export const REQUEST_CAPTURE_GUIDE = 'REQUEST_CAPTURE_GUIDE';
export const CAPTURE_GUIDE_RECEIVED = 'CAPTURE_GUIDE_RECEIVED';

